var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupLayer
OCS.Viewer.Functions.define_layer_group_legend_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupLegend = {
        has_legend: true,
        mouse_select: false,
        allow_mouse_select: true,
        allow_mouse_over: true,
        container: null,
        legend_container: null,
        legend_group_container_string: "legend_group_container",
        init_layer_group_legend: function () {
            this.bound_methods.on_legend_container_created = this.on_legend_container_created.bind(this);
            this.bound_methods.on_activate_layer_group_legend = this.on_activate_layer_group_legend.bind(this);
            this.init_legend_events();
        },

        create_legend_group_container: function () {
            if (this.container) {
                var legend_id = this.get_legend_layer_group_container_id();
                this.legend_container = new Element('div', {'class': "map_" + this.legend_group_container_string + " " + this.class_name + "_legend", id: legend_id}).inject(this.container);
                this.legend_container.addClass('hidden');
                this.fireEvent('legend_container_created', this);
            }
            return this.legend_container;
        },

        init_legend_events: function () {
            this.addEvent('destroy_layer_group', this.destroy_legend.bind(this));
            this.addEvent('remove_layer', this.on_remove_layer_legend.bind(this));
            this.addEvent('activate_layer', this.on_activate_layer_wlegend.bind(this));
            this.addEvent('layer_deactive', this.on_deactivate_layer_wlegend.bind(this));
            this.addEvent('activate_layer_legend', this.on_activate_layer_group_legend.bind(this));
            this.addEvent('deactivate_layer_legend', this.on_deactivate_layer_group_legend.bind(this));

            this.addEvent('mouse_click', this.on_mouse_click.bind(this));
            this.addEvent('mouse_over', this.on_mouse_over.bind(this));

        },
        mouse_click: function (mouse_position) {
            if (this.allow_mouse_select) {
                this.fireEvent('mouse_click', [{mouse_position: mouse_position}, this], 1);
            }
        },
        mouse_over: function (mouse_position) {
            if (this.allow_mouse_over) {
                this.fireEvent('mouse_over', [{mouse_position: mouse_position}, this], 1);
            }
        },
        get_legend_layer_group_container_id: function () {
            return this.get_id() + "_" + this.legend_group_container_string;
        },

        get_layer_legend_visibility: function () {
            if (this.legend_container) {
                return !this.legend_container.hasClass('hidden');
            }
            return false;
        },
        get_frac: function (trackLonLat) {
            var layer = this.get_active_layer();
            if (layer) {
                return layer.get_frac(trackLonLat);
            }
        },
        get_legend_status_text: function (trackLonLat) {
            var layer = this.get_active_layer();
            if (layer) {
                return layer.get_legend_status_text(trackLonLat);
            }
        },
        get_legend_tooltip_text: function (trackLonLat) {
            var layer = this.get_active_layer();
            if (layer) {
                return layer.get_legend_tooltip_text(trackLonLat);
            }
        },
        get_legend_canvas: function () {
            var layer = this.get_active_layer();
            if (layer) {
                return layer.get_legend_canvas();
            }
        },
        get_legend_container: function () {
            if (!this.legend_container && this.container) {
                return this.create_legend_group_container();
            }
            return this.legend_container;
        },
        get_source_obj: function () {
            return this.get_active_layer_source_obj();
        },
        set_container: function (el) {
            this.container = el;
            this.get_legend_container();
        },
        on_legend_container_created: function (hc) {
            hc.removeEvent('legend_container_created', this.bound_methods.on_legend_container_created);
            this.set_container(hc.legend_container.legend_content_container);
        },
        on_remove_layer_legend: function (layer_obj) {
            if (layer_obj.remove_legend_canvas) {
                layer_obj.remove_legend_canvas();
            }
        },

        on_activate_layer_wlegend: function (layer_obj) {
            var container = this.get_legend_container();
            if (layer_obj && container) {
                layer_obj.fireEvent('activate_layer_legend', container);
            }
        },
        on_deactivate_layer_wlegend: function (layer_obj) {
            if (layer_obj) {
                layer_obj.fireEvent('deactivate_layer_legend');
            }
        },
        on_activate_layer_group_legend: function () {
            if (!this.legend_container) {
                this.create_legend_group_container();
            }
            if (this.legend_container) {
                var layer = this.get_active_layer();
                if (layer) {
                    this.on_activate_layer_wlegend(layer);
                }
                this.legend_container.removeClass('hidden');
                this.fireEvent('layer_legend_activated', this);
            } else {
                // Lets try again once the container is created
                this.addEvent('legend_container_created', this.bound_methods.on_activate_layer_group_legend);
            }
            
            
        },
        on_deactivate_layer_group_legend: function () {
            var layer = this.get_active_layer();
            if (layer) {
                layer.fireEvent('deactivate_layer_legend');
            }
            if (this.legend_container) {
                this.legend_container.addClass('hidden');
            } else {
                if(this.$events.legend_container_created) {
                    this.removeEvent('legend_container_created', this.bound_methods.on_activate_layer_group_legend);
                }
            }
            this.fireEvent('layer_legend_deactivated', this);
        },
        on_mouse_click: function (mouse_position) {

        },
        on_mouse_over: function (mouse_position) {

        },
        destroy_legend: function () {
            if (this.legend_container) {
                this.legend_container.destroy();
                this.legend_container = null;
            }
            var legend = document.id(this.get_legend_layer_group_container_id());
            if (legend) {
                legend.destroy();
            }
            this.legend_container = null;
        }
    };
};
OCS.Viewer.Functions.define_layer_group_legend_interface();





